import { render } from "./FloatingTimer.vue?vue&type=template&id=3462bddb&ts=true"
import script from "./FloatingTimer.vue?vue&type=script&lang=ts"
export * from "./FloatingTimer.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__